module.exports = {
      id: "wi-fi-usage",
      viewBox: "0 0 13 11",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#wi-fi-usage",
      toString: function () {
        return this.url;
      }
    }